import React from "react";
import PanelGroupController from "../../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../../components/panels/PropertiesList";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {Query} from "react-apollo";
import {GET_SHOP} from "../../../queries/inventory";

const ShopPropertiesPanel = (props) => {

  let elements = null;
  if (!props.shopId || props.shopId === "all") {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let properties = fromJS([
      {prop: "shopId", label: "Id", type: "id"},
      {prop: "title", label: "Title", type: "string"},
      {prop: "currencies", label: "Currencies", type: "array"},
      {prop: "defaultCurrency", label: "Default", type: "string"},
    ])
    let variables = {shopId: props.shopId}
    elements = (
      <Query query={GET_SHOP} variables={variables} skip={props.shopId === "all"}>
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          return (
            <PropertiesList properties={properties} data={fromJS(data.shop)} />
          )
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="Shop" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

export default ShopPropertiesPanel;